import { IColumn } from "../types";
import { NameCell } from "../Cells/NameCell";
import { NumberCell } from "../Cells/NumberCell";
import { PrivateEquityPosition } from "@iliotech/generated-api-v3";
import { PercentCell } from "../Cells/PercentCell";

export const PrivateEquitiesTable: IColumn<PrivateEquityPosition>[] = [
  { field: "name", isDefault: true, renderer: NameCell(), title: "ASSET NAME" },
  {
    field: "vintageYear",
    isDefault: true,
    renderer: NameCell(),
    title: "VINTAGE",
  },
  {
    field: "currencyCode",
    isDefault: true,
    renderer: NameCell(),
    title: "CURRENCY",
  },
  {
    field: "committedCapital",
    isDefault: true,
    renderer: NumberCell(),
    title: "COMMITTED",
    rightAligned: true,
  },
  {
    field: "unfunded",
    isDefault: true,
    renderer: NumberCell(),
    title: "UNFUNDED",
    rightAligned: true,
  },
  {
    field: "capitalCalled",
    isDefault: true,
    renderer: NumberCell(),
    title: "CAPITAL CALLED",
    rightAligned: true,
  },
  {
    field: "irr",
    isDefault: true,
    renderer: NumberCell({ maxDecimals: 2 }),
    title: "IRR",
    rightAligned: true,
  },
  {
    field: "distributedCapital",
    isDefault: true,
    renderer: NumberCell(),
    title: "Distribution",
    rightAligned: true,
  },
  {
    field: "dpi",
    isDefault: true,
    renderer: NumberCell({ maxDecimals: 2 }),
    title: "DPI",
    rightAligned: true,
  },
  {
    field: "rvpi",
    isDefault: true,
    renderer: NumberCell({ maxDecimals: 2 }),
    title: "RVPI",
    rightAligned: true,
  },
  {
    field: "tvpi",
    isDefault: true,
    renderer: NumberCell({ maxDecimals: 2 }),
    title: "TVPI",
    rightAligned: true,
  },
];
